// extracted by mini-css-extract-plugin
export default {"pre":"Pre_pre__s6T+t","error":"Pre_error__Khe6A"};